import { Reveal } from "./Reveal";
import Button from "./Button";
import { TALENT_SERVICES } from "../lib/data";

export default function ForTalent() {
  return (
    <section id="for-talent" className="border-t border-charcoal py-16 sm:py-32" data-testid="for-talent">
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-8">
            <Reveal>
              <div className="label mb-6">For Talent</div>
              <h2 className="font-sans font-semibold uppercase text-warm text-4xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-[-0.02em]">
                We build careers.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4">
            <Reveal delay={0.1}>
              <Button as="a" href="#apply" variant="primary" data-testid="talent-cta">
                Join NSTR
              </Button>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-charcoal border border-charcoal">
          {TALENT_SERVICES.map((s, i) => (
            <Reveal key={s.no} delay={(i % 3) * 0.06}>
              <div className="bg-ink p-8 sm:p-10 h-full transition-colors duration-500 hover:bg-charcoal/30" data-testid={`talent-service-${s.no}`}>
                <div className="font-sans text-silver/50 text-sm mb-6">{s.no}</div>
                <h3 className="font-sans font-semibold uppercase text-warm text-xl sm:text-2xl tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-4 text-silver text-sm sm:text-base font-light leading-relaxed">
                  {s.copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
